import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_B2B_API_BASE_URL;

export const carApi = async (payload) => {
  let url;
  if (payload?.location) {
    url = `${env}${API_ENDPOINT.Car.api}?type=${payload?.type}&contractId=${payload?.contractId}&location=${payload?.location}`;
  } else {
    url = `${env}${API_ENDPOINT.Car.api}?contractId=${payload?.contractId}`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const  carFacilities = async(data) => {
  let url = `${env}${API_ENDPOINT.Car.facilities +"/"+data}`
  const res = await requestInstance.get(
    url
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}
